export default __webpack_public_path__ + "static/media/pdf2.1fb2d6ed.svg";